import React from "react"
import { MenuItem, TextField, Box } from "@mui/material"
import { ToggleButton } from "@mui/material"
import Icon from "@mdi/react"
import { mdiHelpCircle } from "@mdi/js"

import SystemConfigurationDialog from "components/Dialogs/SystemConfigurationDialog"
import { StyledToggleButtonGroup } from "components/Configurations/SystemAndLengthCombinationConfigurationInput"

import {
	DispatchProductDetailPageReducer,
	ProductDetailPageReducerState,
	setVariant,
} from "@secureo/common/reducers/productDetailPageReducer"

const SimpleConfiguration = ({ isLoading, dispatch, reducerState }: Props) => {
	const {
		variantId,
		variantsByVariantId,
		attributes: { systemConfigurationToolTip },
	} = reducerState

	const variants = Object.values(variantsByVariantId)
	const numberOfVariants = variants.length

	const onVariantChange = (variantId: number) => {
		setVariant(dispatch, reducerState, variantId)
	}

	if (numberOfVariants > 10)
		return (
			<div>
				<Box mt={1} mb={1} style={{ display: "flex", alignItems: "center" }}>
					<SystemConfigurationDialog
						systemConfigurationToolTip={systemConfigurationToolTip}
					/>
				</Box>
				<TextField
					id="variant"
					label="Ausführung"
					value={variantId}
					onChange={(event) => onVariantChange(Number(event.target.value))}
					margin="normal"
					variant="filled"
					select
					fullWidth
					disabled={isLoading}
				>
					{Object.entries(variantsByVariantId).map(([variantId, variant]) => {
						if (Number(variantId) === 1) return null

						const variantName =
							variant?.attributes?.variantName?.replace(/.+,\s/, "") ?? variant?.sku

						return (
							<MenuItem key={variantId} value={variantId}>
								{variantName}
							</MenuItem>
						)
					})}
				</TextField>
			</div>
		)

	return (
		<div>
			<Box mb={1} style={{ display: "flex", alignItems: "center" }}>
				<Box mr={1}>
					<strong>Ausführung wählen</strong>
				</Box>
				<Icon path={mdiHelpCircle} size={0.8} color="#4691CE" />
			</Box>

			<StyledToggleButtonGroup
				value={variantId}
				exclusive
				onChange={(_, variantId) => onVariantChange(Number(variantId))}
				aria-label="text alignment"
				style={{ display: "flex", flexWrap: "wrap" }}
			>
				{variants.map((variant) => {
					const { id: variantId } = variant

					if (Number(variantId) === 1) return null

					const variantName =
						variant?.attributes?.variantName?.replace(/.+,\s/, "") ?? variant?.sku

					return (
						<ToggleButton
							key={variantId}
							value={variantId}
							disabled={isLoading}
							style={{ marginBottom: 8 }}
						>
							<strong>{variantName}</strong>
						</ToggleButton>
					)
				})}
			</StyledToggleButtonGroup>
		</div>
	)
}

interface Props {
	isLoading: boolean
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
}

export default SimpleConfiguration
